/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import axios from "axios";

// import parse from "html-react-parser";

import '../../css/event220916_2.css';
// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
import moment from 'moment';
// import { isMobile } from "react-device-detect";
//import $ from 'jquery';
// import ReactPlayer from "react-player";
// import Slider from "react-slick";

// import Timer from "react-timer-wrapper";
// import Timecode from "react-timecode";

// import ItemBox from "../../components/aketo/ItemBox";

// import { now } from "lodash";

class Event2025_agf extends Component {
  state = {
    tabIndex: 0,
  };

  componentDidMount = () => {};
  changeTab = (tab) => {
    if (tab !== 2) {
      this.setState({
        tabIndex: tab,
      });
    } else {
      if (
        moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >=
        '2024-11-28 17:00:00'
      ) {
        this.setState({
          tabIndex: tab,
        });
      } else {
        alert('준비중입니다.');
      }
    }
  };
  render() {
    const { tabIndex } = this.state;
    const { imgUrl } = this.props;

    return (
      <Fragment>
        <div className="event_head">
          <h3>AGF2025</h3>
          <button type="button" className="btnClose">
            <img src={imgUrl + '/img/detail_img/close_1.png'} alt="닫기" />
          </button>
        </div>
        <div className="eventCon">
          <div className="event220916_2" style={{ color: '#fff' }}>
            <img src={'/img/event/event2025_agf/img_main.png'} />
          </div>
          <div>
            <span
              onClick={() => this.changeTab(0)}
              style={{ cursor: 'pointer' }}
            >
              <img
                src={
                  tabIndex === 0
                    ? '/img/event/event2025_agf/tab01_on.png'
                    : '/img/event/event2025_agf/tab01_off.png'
                }
                style={{ width: '50%', padding: 0, margin: 0 }}
              />
            </span>
            <span
              onClick={() => this.changeTab(1)}
              style={{ cursor: 'pointer' }}
            >
              <img
                src={
                  tabIndex === 1
                    ? '/img/event/event2025_agf/tab02_on.png'
                    : '/img/event/event2025_agf/tab02_off.png'
                }
                style={{ width: '50%', padding: 0, margin: 0 }}
              />
            </span>
            {/* <span
              onClick={() => this.changeTab(2)}
              style={{ cursor: 'pointer' }}
            >
              <img
                src={
                  tabIndex === 2
                    ? '/img/event/event2025_agf/tab03_on.png'
                    : '/img/event/event2025_agf/tab03_off.png'
                }
                style={{ width: '33.33%', padding: 0, margin: 0 }}
              />
            </span> */}
          </div>

          {tabIndex === 0 ? (
            <Fragment>
              <div name="00_MD">
                <img
                  src={'/img/event/event2025_agf/Goods_Top.png'}
                  useMap="#image-map"
                  style={{ width: 1734 }}
                />
              </div>
              <div>
                <a name="01_MD"></a>
                <img
                  src={'/img/event/event2025_agf/MD_01.png'}
                  style={{ width: 1734 }}
                />
              </div>
              <div>
                <a name="02_MD"></a>
                <img
                  src={'/img/event/event2025_agf/MD_02_1.png'}
                  style={{ width: 1734 }}
                />
              </div>
              <div>
                <a name="03_MD"></a>
                <img
                  src={'/img/event/event2025_agf/MD_03.png'}
                  style={{ width: 1734 }}
                />
              </div>
              <div>
                <a name="04_MD"></a>
                <img
                  src={'/img/event/event2025_agf/MD_04.png'}
                  style={{ width: 1734 }}
                />
              </div>
              <div>
                <a name="05_MD"></a>
                <img
                  src={'/img/event/event2025_agf/MD_05_1.png'}
                  style={{ width: 1734 }}
                />
              </div>
              <map name="image-map">
                <area
                  target=""
                  alt="1"
                  title="1"
                  href="#01_MD"
                  coords="81,346,580,546"
                  shape="rect"
                />
                <area
                  target=""
                  alt="2"
                  title="2"
                  href="#02_MD"
                  coords="600,342,1099,540"
                  shape="rect"
                />
                <area
                  target=""
                  alt="3"
                  title="3"
                  href="#03_MD"
                  coords="1120,345,1619,543"
                  shape="rect"
                />
                <area
                  target=""
                  alt="4"
                  title="4"
                  href="#04_MD"
                  coords="339,562,839,765"
                  shape="rect"
                />
                <area
                  target=""
                  alt="5"
                  title="5"
                  href="#05_MD"
                  coords="860,564,1354,762"
                  shape="rect"
                />
              </map>
            </Fragment>
          ) : tabIndex === 1 ? (
            <Fragment>
              <div name="00_CAFE">
                <img
                  src={'/img/event/event2025_agf/Cafe_Top.png'}
                  useMap="#image-map1"
                  style={{ width: 1734 }}
                />
              </div>
              <div>
                <a name="01_CAFE"></a>
                <img
                  src={'/img/event/event2025_agf/Cafe_01.png'}
                  style={{ width: 1734 }}
                />
              </div>
              <div>
                <a name="02_CAFE"></a>
                <img
                  src={'/img/event/event2025_agf/Cafe_02_1.png'}
                  style={{ width: 1734 }}
                />
              </div>
              <div>
                <a name="03_CAFE"></a>
                <img
                  src={'/img/event/event2025_agf/Cafe_03.png'}
                  style={{ width: 1734 }}
                />
              </div>
              <div>
                <a name="04_CAFE"></a>
                <img
                  src={'/img/event/event2025_agf/Cafe_04.png'}
                  style={{ width: 1734 }}
                />
              </div>

              <map name="image-map1">
                <area
                  target=""
                  alt="1"
                  title="1"
                  href="#01_CAFE"
                  coords="351,342,844,540"
                  shape="rect"
                />
                <area
                  target=""
                  alt="2"
                  title="2"
                  href="#02_CAFE"
                  coords="868,345,1367,541"
                  shape="rect"
                />
                <area
                  target=""
                  alt="3"
                  title="3"
                  href="#03_CAFE"
                  coords="346,561,851,760"
                  shape="rect"
                />
                <area
                  target=""
                  alt="4"
                  title="4"
                  href="#04_CAFE"
                  coords="866,565,1367,765"
                  shape="rect"
                />
              </map>
            </Fragment>
          ) : (
            <Fragment></Fragment>
          )}
          <div>
            <img
              src="/img/event/event2025_agf/notice.png"
              style={{ width: 1734 }}
            />
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event2025_agf));
